import InfoBar from './InfoBar';

export default InfoBar;
